
import ImageContainerViewModel from '@/entities/ImageContainerViewModel';
import { Vue, Component, Prop, Watch, toNative } from 'vue-facing-decorator';
import Editor from '@/components/Common/Editor.vue';
import ImageContainer from '@/components/Common/ImageContainer.vue';
import EmailTemplateRenderer from '../Templates/EmailTemplateRenderer.vue';
import { Twitter } from '@ckpack/vue-color';
import { app, FetchData , Root, Store, t} from '@/main';
import ConfigureEmailEditPaneModalPopUp from './ConfigureEmailEditPaneModalPopUp.vue';
import { EmailTemplate } from '@/entities/Invite/EmailTemplateViewModel';
import vClickOutside from 'click-outside-vue3';
import ImageProcess from '@/components/Common/ImageProcess.vue';
import loading from '@/components/Common/loading.vue';
import Toaster from '@/components/Common/Toaster.vue';
import { required, minLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { reactive } from 'vue';
import InviteEmailFontsEnum from '@/enums/InviteEmailFontsEnum';
import ConfigureEmailsHelper from '@/helper/ConfigureEmailsHelper';
import InviteEmailLogoPositionsEnum from '@/enums/InviteEmailLogoPositionsEnum';
import { ModalInputPopUpViewModel } from '@/entities/ModalInputPopUpViewModel';
import SubModulePrefix from '@/enums/SubModulePrefix';
import { VueModalPopUpViewModel } from '@/entities/VueModalPopUpViewModel';
import VueModalPopUp from '@/components/Common/VueModalPopUp.vue';
import ValidationSummary from '@/components/Common/ValidationSummary.vue';
import MergeTags from '@/entities/MergeTags';
import { TelerikImageUploadViewModel } from '@/entities/TelerikImageUploadViewModel';
import ApiContentType from '@/enums/ApiContentType';
import ModuleTypeEnum from '@/enums/ModuleTypeEnum';
import { StoreHelper } from '@/store/StoreHelper';
import { AppColorSettingsInfo } from '@/entities/Application/AppColorSettingsInfo';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import InviteConfirmationEmailEnum from '@/enums/InviteConfirmationEmailEnum';
import InviteCTATypeEnum from '@/enums/InviteCTATypeEnum';
import ModalInputType from '@/enums/ModalInputType';
import EmailTemplatesTableModel from '@/entities/Invite/EmailTemplatesTableModel';
import InviteImageTypeEnum from '@/enums/InviteImageTypeEnum';
import InviteActionTypeEnum from '@/enums/InviteActionTypeEnum';
import { ModalInputPopUpValidationsModel } from '@/entities/ModalInputPopUpValidationsModel';
import { CustomEmailEditPanePopUpModal } from '@/entities/Invite/CustomEmailTableInputModel';
import ModalInputPopUp from '@/components/Common/ModalInputPopUp.vue';
import InviteEventWebPageEmailTypeEnum from '@/enums/InviteEventWebPageEmailTypeEnum';
import { CorporateFontEntry } from '@/entities/Invite/CorporateFontModel';


@Component({
  components : {
    ImageContainer,
    EmailTemplateRenderer,
    Editor,
    Twitter,
    ConfigureEmailEditPaneModalPopUp,
    ImageProcess,
    loading,
    Toaster,
    VueModalPopUp,
    ValidationSummary,
    ModalInputPopUp,
  },
})
class ConfigureEmailEditPane extends Vue{
  // Prop
  @Prop() templatePreviewData!: EmailTemplate;

  // Corporate fonts for this application, supplied by the parent and merged into the font dropdown
  @Prop({ default: () => [] }) corporateFonts!: CorporateFontEntry[];

  // Icon images on the screen
  private emailIcon = require('@/assets/Images/Invite/blue-email-envelope.svg');
  private missingImage: string = require('@/assets/Images/ImageMissingFeature.png');
  private missingFeatureImage: string = require('@/assets/Images/icon-placeholder.svg');

  // Calender Icon
  private calenderIcon: string = require('@/assets/Images/Invite/calender-icon.png');
  private copyIcon: string = require('@/assets/Images/copy-icon.svg');

  // Store helper for accessing default CTA colors
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private reqInfo: AppRequestInfo = this.storeHelper.GetRequestInfoFromStore();

  // Hero Image & Logo Image variables
  private customEmailLogoData: ImageContainerViewModel = ImageContainerViewModel.createEmpty();
  private customEmailHeroImageData: ImageContainerViewModel = ImageContainerViewModel.createEmpty();

  // variables for email colors
  private bodyBackgroundColor = {hex: ''};
  private bodyFontColor = {hex: ''};
  private headerBackgroundColor = {hex: ''};
  private footerBackgroundColor = {hex: ''};
  private footerFontColor = {hex: ''};
  private registerButtonBackgroundColor = {hex: ''};
  private registerButtonFontColor = {hex: ''};
  private editButtonBackgroundColor = {hex : ''};
  private editButtonFontColor = {hex : ''};
  private eventAccessButtonBackgroundColor = {hex : ''};
  private eventAccessButtonFontColor = {hex : ''};
  private eventWebPageButtonBackgroundColor = {hex: ''};
  private eventWebPageButtonFontColor = {hex: ''};
  private isPaletteSelected = [false,false,false,false,false,false,false,false,false,false,false,false,false];

  // Logo Position & link or button variables, fonts
  private logoPositions = Object.values(InviteEmailLogoPositionsEnum);

  private loaderBorderColor = '';
  private moduleName = ConfigureEmailsHelper.ModuleName;
  private subModuleName = '';
  private toasterType = ConfigureEmailsHelper.ToasterType;
  // Flags for conditional logic
  private showImageProcess = false;
  private showLoading = false;
  private showToaster = false;
  private showHeroImage = false;
  private showConfigureEmailEditPaneModal = false;
  private showEmailModalPopUp = false;
  private isPageDirty = false;
  private showVueModalPopUp = false;
  private isSmallTab = false;

  // Maximum length for input fields
  private maxSubjectLength = ConfigureEmailsHelper.MaxSubjectLength;
  private maxButtonTextLength = ConfigureEmailsHelper.MaxButtonTitleLength;

  // Variable holding merge tags data
  private mergeTags = new MergeTags();

  // Validation Summary flag
  private isValidationSummaryVisible = false;
  private validationErrorFields: string[] = [];

  // clone object to work on edit email data
  private editTemplateData: EmailTemplate =  EmailTemplate.createEmpty();

  // Validation, input and table model op up for edit page
  private customEmailModalPopUp: CustomEmailEditPanePopUpModal = CustomEmailEditPanePopUpModal.createEmpty();
  private unsavedModalPopUp: VueModalPopUpViewModel = VueModalPopUpViewModel.createEmpty();
  private emailModalPopUp: ModalInputPopUpViewModel = ModalInputPopUpViewModel.createEmpty();

  // variables for email body font , button & toaster messages
  private toasterDefaultTimeout = ConfigureEmailsHelper.ToasterTimeOut;
  private loaderDefaultTimeout = ConfigureEmailsHelper.LoaderTimeOut;
  private toasterMessage = '';
  private previewEmailBody = '';
  private imagesToBeUploaded: TelerikImageUploadViewModel[] = [];
  private showFontFamilyInformation = false;
  private showEventPageNotPublishInformation = false;

  // Default Header,Footer colors and logo
  private defaultBackgroundColor = '';
  private defaultForegroundColor = '';
  private defaultLogo = '';

  // Boolean flags to switch between Landing page & Templates gallery screen
  private shouldSwitchToTemplatesScreen = false;
  private shouldSwitchToHomeScreen = false;

  // Vue Validation states & rules logic

  private state = reactive({
    editTemplateData: EmailTemplate.createEmpty(),
  });

  private rules= {
    editTemplateData: {
      TemplateData: {
        EmailSubject : {
          required,
          minLength: minLength(1),
        },
        LabelText : {
          required,
          minLength: minLength(1),
        },
        EditResponsesLabelText : {
          required,
          minLength: minLength(1),
        },
        EventAccessLabelText: {
          required,
          minLength: minLength(1),
        },
        EventWebPageAccessLabelText:{
          required,
          minLength: minLength(1),
        },
      },
    },
  };

  private status(validation: { $error: any; $dirty: any }) {
    return {
      error: validation.$error,
      dirty: validation.$dirty,
    };
  }
  private v$ = useVuelidate(this.rules, this.state);

  // Getter for font options — the standard fonts plus any corporate fonts available for this application
  public get fontOptions(): string[] {
    const fonts = Object.values(InviteEmailFontsEnum);
    const corporate = Array.isArray(this.corporateFonts) ? this.corporateFonts.map((font) => font.FontFamily) : [];
    return [...fonts, ...corporate];
  }

  // Prop to get the module type
  public get currentComponent(): typeof ModuleTypeEnum {
    return ModuleTypeEnum;
  }

  // Getter for Confirmation Email type
  public get emailType(): typeof InviteConfirmationEmailEnum {
    return InviteConfirmationEmailEnum;
  }

  // Getter for Button type
  public get buttonType(): typeof InviteCTATypeEnum {
    return InviteCTATypeEnum;
  }

  // Getter for Image type
  public get imageType(): typeof InviteImageTypeEnum {
    return InviteImageTypeEnum;
  }

  // Mounted life cycle hook
  private mounted(){
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    app.use(vClickOutside);
    this.GetDefaultDataFromStoreHelper();
    this.SetDefaultEmailSettings();
    this.GetEventWebPageStatus();
    this.editTemplateData = JSON.parse(JSON.stringify(this.templatePreviewData));
    this.state.editTemplateData = this.editTemplateData;
    if(window.innerWidth <= 1200){
      this.isSmallTab = true;
    }else{
      this.isSmallTab = false;
    }
    this.IsPageDirty();
    this.SetLogoData();
    this.SetHeroImageData();
    this.SetDefaultColors();
    this.GenerateBodyHTML();
    Root.on('SetFeaturedImageIconUrl', (val: string)=>{
      this.SetHerologoUrl(val);
    });
    Root.on('show-toaster', ()=> {
      this.ShowToasterAndLoader(t('CopiedSuccessfully'));
    });
  }


  // Check whether the Event web page is published or not
  private GetEventWebPageStatus(){
    FetchData('/Registration/GetEventPagePublishedStatus','').then((response)=>{
      if(response.Success && response.IsPublished){
        this.showEventPageNotPublishInformation = false;
      } else {
        this.showEventPageNotPublishInformation = true;
      }
    }).catch(()=>{
      this.showEventPageNotPublishInformation = true;
    });
  }

  // Get Default Header & Footer colors and logo url
  private GetDefaultDataFromStoreHelper(){
    const appcolors: AppColorSettingsInfo =  this.storeHelper.GetApplicationColorSettingsFromStore();
    this.defaultBackgroundColor = appcolors.topNavBackgroundColor;
    this.defaultForegroundColor = appcolors.topNavForegroundColor;
    this.defaultLogo = this.reqInfo.LogoURI;
  }

  // Build Button or link in Preview
  private GenerateBodyHTML(){
    this.previewEmailBody = this.editTemplateData.TemplateData.EmailBody;
    this.previewEmailBody = this.editTemplateData.TemplateData.EmailBody.replace( /\{\{AddToCalendarIMG\}\}/gi,
      `<img src="${this.calenderIcon}" alt="Calendar" />`);
    const backgroundColor   = this.editTemplateData.TemplateData.BackgroundColor || this.defaultBackgroundColor;
    const buttonText  = this.editTemplateData.TemplateData.LabelText || ConfigureEmailsHelper.RegisterOrEditButtonText;
    const textColor   = this.editTemplateData.TemplateData.LabelColor || this.defaultForegroundColor;

    if(this.editTemplateData.TemplateData.HasRegistrationLink){
      this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, backgroundColor, buttonText, textColor, 'RegistrationLinkOrButton', InviteActionTypeEnum.Link);
    }else{
      this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, backgroundColor, buttonText, textColor, 'RegistrationLinkOrButton', InviteActionTypeEnum.Button);
    }

    if(this.editTemplateData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.Invitation || this.editTemplateData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.InvitationReminder || this.editTemplateData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.Custom){
      const eventWebPageBg    = this.editTemplateData.TemplateData.EventWebPageAccessBackgroundColor || this.defaultBackgroundColor;
      const eventWebPageText  = this.editTemplateData.TemplateData.EventWebPageAccessLabelText || ConfigureEmailsHelper.EventWebPageButtonText;
      const eventWebPageColor = this.editTemplateData.TemplateData.EventWebPageAccessLabelColor || this.defaultForegroundColor;
      if(this.editTemplateData.TemplateData.HasEventWebPageAccessLink){
        this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, eventWebPageBg, eventWebPageText, eventWebPageColor, 'EventWebPageLink', InviteActionTypeEnum.Link);
      } else {
        this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, eventWebPageBg, eventWebPageText, eventWebPageColor, 'EventWebPageLink', InviteActionTypeEnum.Button);
      }
    }

    if(this.editTemplateData.TemplateData.TemplateType === InviteConfirmationEmailEnum.Confirmation || this.editTemplateData.TemplateData.TemplateType === InviteConfirmationEmailEnum.ConfirmationTickets){
      const editBackgroundColor = this.editTemplateData.TemplateData.EditResponsesBackgroundColor || this.defaultBackgroundColor;
      const editButtonText = this.editTemplateData.TemplateData.EditResponsesLabelText || ConfigureEmailsHelper.RegisterOrEditButtonText;
      const editTextColor = this.editTemplateData.TemplateData.EditResponsesLabelColor || this.defaultForegroundColor;
      if(this.editTemplateData.TemplateData.HasEditResponsesRegistrationLink){
        this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, editBackgroundColor, editButtonText, editTextColor, 'EditResponsesLink',InviteActionTypeEnum.Link);
      }else{
        this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, editBackgroundColor, editButtonText, editTextColor, 'EditResponsesLink',InviteActionTypeEnum.Button);
      }
      const eventAccessBackgroundColor   = this.editTemplateData.TemplateData.EventAccessBackgroundColor || this.defaultBackgroundColor;
      const eventAccessLabelText  = this.editTemplateData.TemplateData.EventAccessLabelText || ConfigureEmailsHelper.EventAccessButtonText;
      const eventAccessLabelColor   = this.editTemplateData.TemplateData.EventAccessLabelColor || this.defaultForegroundColor;
      if(this.editTemplateData.TemplateData.HasEventAccessLink){
        this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, eventAccessBackgroundColor, eventAccessLabelText, eventAccessLabelColor, 'EventAccessLink', InviteActionTypeEnum.Link);
        this.previewEmailBody = this.reqInfo.EnablePersonalisedEventAccessLink ? this.ReplaceButtonTag(this.previewEmailBody, eventAccessBackgroundColor, eventAccessLabelText, eventAccessLabelColor, 'PersonalEventAccessLink', InviteActionTypeEnum.Link) : this.previewEmailBody;
      } else {
        this.previewEmailBody = this.ReplaceButtonTag(this.previewEmailBody, eventAccessBackgroundColor, eventAccessLabelText, eventAccessLabelColor, 'EventAccessLink', InviteActionTypeEnum.Button);
        this.previewEmailBody = this.reqInfo.EnablePersonalisedEventAccessLink ? this.ReplaceButtonTag(this.previewEmailBody, eventAccessBackgroundColor, eventAccessLabelText, eventAccessLabelColor, 'PersonalEventAccessLink', InviteActionTypeEnum.Button) : this.previewEmailBody;
      }
    }
    const html = this.BuildProcessedHtml();
    this.editTemplateData.ProcessedHtml = html;
  }

  // Created button from tags to be used in Send Grid Template
  private CreateCTAButton(backgroundColor: string, label: string , labelColor: string) {
    return `<a style='background-color: ${backgroundColor}; color: ${labelColor}; text-decoration: none; font-weight: bold; padding: 12px 24px; display: inline-block; border-radius: 10px;'>${label}</a>`;
  }

  // Create Link from tag
  private CreateCTALink(label: string , labelColor: string){
    return `<a style=' color: ${labelColor}; text-decoration: underline;'>${label}</a>`;
  }

  // Function closing validation summary
  private CloseValidationSummary(visible: boolean) {
    this.isValidationSummaryVisible = visible;
  }

  // Handler for creating buttons on SendGrid
  private ReplaceButtonTag(body: string, backgroundColor: string, label: string,labelColor: string, placeholder: string , type: number) {
    let cta = '';
    if(type === InviteActionTypeEnum.Button){
      cta = this.CreateCTAButton(backgroundColor, label , labelColor);
    } else{
      cta = this.CreateCTALink(label, labelColor);
    }
    return body.replace(new RegExp(`{{${placeholder}}}`, 'gi'), cta);
  }

  // Set Default email configurtions on page load
  private SetDefaultEmailSettings(){
    this.templatePreviewData.TemplateData.FontFamily = this.templatePreviewData.TemplateData.FontFamily || ConfigureEmailsHelper.FontFamily;
    this.templatePreviewData.TemplateData.LogoPosition = this.templatePreviewData.TemplateData.LogoPosition || ConfigureEmailsHelper.LogoPosition;
    this.templatePreviewData.TemplateData.HeroImageUrl = this.templatePreviewData.TemplateData.HeroImageUrl;
    this.templatePreviewData.TemplateData.EventAccessLabelText = this.templatePreviewData.TemplateData.EventAccessLabelText || ConfigureEmailsHelper.EventAccessButtonText;
    this.templatePreviewData.TemplateData.EventAccessBackgroundColor = this.templatePreviewData.TemplateData.EventAccessBackgroundColor || this.defaultBackgroundColor;
    this.templatePreviewData.TemplateData.EventAccessLabelColor = this.templatePreviewData.TemplateData.EventAccessLabelColor || this.defaultForegroundColor;
    this.templatePreviewData.TemplateData.EventWebPageAccessLabelText = this.templatePreviewData.TemplateData.EventWebPageAccessLabelText || ConfigureEmailsHelper.EventWebPageButtonText;
    this.templatePreviewData.TemplateData.EventWebPageAccessBackgroundColor = this.templatePreviewData.TemplateData.EventWebPageAccessBackgroundColor || this.defaultBackgroundColor;
    this.templatePreviewData.TemplateData.EventWebPageAccessLabelColor = this.templatePreviewData.TemplateData.EventWebPageAccessLabelColor || this.defaultForegroundColor;
    this.editTemplateData.TemplateData.FontFamily = this.editTemplateData.TemplateData.FontFamily || InviteEmailFontsEnum.Verdana;
    this.editTemplateData.TemplateData.EditResponsesLabelText = this.editTemplateData.TemplateData.EditResponsesLabelText || ConfigureEmailsHelper.RegisterOrEditButtonText;
  }

  // Function to return true / false depending on if email type is Confirmation or Confirmation Tickets
  private HasConfirmationTemplate(): boolean {
    if(this.templatePreviewData.TemplateData.TemplateType === InviteConfirmationEmailEnum.Confirmation || this.templatePreviewData.TemplateData.TemplateType === InviteConfirmationEmailEnum.ConfirmationTickets){
      return true;
    }
    return false;
  }

  // Function to return true / false depending on if email type is Invitation / Ticketed Invitation or Custom
  private HasEventWebPageAccessTemplate(): boolean{
    if((this.templatePreviewData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.Invitation || this.templatePreviewData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.InvitationReminder || this.templatePreviewData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.Custom)
      && this.editTemplateData.TemplateData.EmailBody.includes('{{EventWebPageLink}}')){
      return true;
    }
    return false;
  }

  // Function to return bool value depending if the event has personal event access link access
  private EventAccessLinkLabel(): string {
    if(this.reqInfo.EnablePersonalisedEventAccessLink && this.HasConfirmationTemplate()){
      return this.$t('Invite.ConfigureEmails.EventAccessLink').toString() + this.$t('BackSlash').toString() + this.$t('Invite.ConfigureEmails.PersonalisedEventAccessLink').toString();
    }
    return this.$t('Invite.ConfigureEmails.EventAccessLink').toString();
  }

  // Handler to send preview email to a recipient
  private SendPreviewMail(userInput: any){
    if(!this.IsMandatoryFieldsFilled()){
      return;
    }
    this.showLoading = true;
    this.showConfigureEmailEditPaneModal = false;
    this.editTemplateData.TemplateData.TestEmailReceiver = userInput;

    const formData = new FormData();
    const json = JSON.stringify(this.editTemplateData.TemplateData);
    // Encode json string to base64 using Buffer:
    const b64 = Buffer.from(json, 'utf-8').toString('base64');
    formData.append('emailConfirgurationData',b64);
    if(!!this.imagesToBeUploaded && this.imagesToBeUploaded.length > 0) {
      this.imagesToBeUploaded.forEach((imageUpload, index) => {
        // Append metadata as JSON or individual fields
        formData.append(`telerikImagesUploads[${index}].Id`, imageUpload.Id);
        formData.append(`telerikImagesUploads[${index}].ImageWidth`, imageUpload.ImageWidth.toString());
        formData.append(`telerikImagesUploads[${index}].ImageHeight`, imageUpload.ImageHeight.toString());
        formData.append(`telerikImagesUploads[${index}].File`, imageUpload.File!);
      });
    }
    FetchData('/Registration/SendEmailForPreview', formData, ApiContentType.FormData).then(() => {
      this.toasterType = ConfigureEmailsHelper.ToasterType;
      this.ShowToasterAndLoader(this.$t('Invite.ConfigureEmails.EmailSentSuccessfully').toString());
    }).catch(()=>{
      // Log errors if any
      this.showLoading = false;
    });
    this.editTemplateData.TemplateData.TestEmailReceiver = null;
  }

  // Handler for logo postions change
  private ChangeLogoPosition(position: string){
    this.editTemplateData.TemplateData.LogoPosition = position;
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Replace Tags inside SendGrid raw HTML
  private BuildProcessedHtml(){
    const html = this.editTemplateData.RawHtml;
    return html
      .replace(/{{LOGO_URI}}/g, this.editTemplateData.TemplateData.LogoUrl || (!!this.editTemplateData.TemplateData.HeaderAccentColor ? '' : this.defaultLogo))
      .replace(/{{HERO_IMAGE_URL}}/g, this.editTemplateData.TemplateData.HeroImageUrl)
      .replace(/{{LOGO_POSITION}}/g, this.editTemplateData.TemplateData.LogoPosition)
      .replace(/{{{CUSTOM_FONT}}}/g, this.GetCustomCorporateFont(this.editTemplateData.TemplateData.FontFamily))
      .replace(/{{HEADER_ACCENT_COLOR}}/g, this.editTemplateData.TemplateData.HeaderAccentColor || this.defaultBackgroundColor)
      .replace(/{{EMAIL_BODY_TEXT_COLOR}}/g, this.editTemplateData.TemplateData.EmailTextColor || ConfigureEmailsHelper.EmailTextColor)
      .replace(/{{EMAIL_ACCENT_COLOR}}/g, this.editTemplateData.TemplateData.EmailAccentColor || ConfigureEmailsHelper.EmailAccentColor)
      .replace(/{{FOOTER_ACCENT_COLOR}}/g, this.editTemplateData.TemplateData.FooterAccentColor || this.defaultBackgroundColor)
      .replace(/{{FOOTER_TEXT_COLOR}}/g, this.editTemplateData.TemplateData.FooterTextColor || this.defaultForegroundColor)
      .replace(/{{{BODY_CONTENT}}}/g, this.previewEmailBody)
      .replace(/{{{FOOTER_CONTENT}}}/g, this.editTemplateData.TemplateData.FooterContent || ConfigureEmailsHelper.FooterContent);
  }

  // Injects the corporate @font-face rules only when a corporate font is selected, otherwise nothing
  private GetCustomCorporateFont(fontFamily: string): string {
    const entry = this.corporateFonts.find((font) => font.FontFamily === fontFamily);
    return entry ? ConfigureEmailsHelper.BuildCorporateFontFaces(entry) : '';
  }

  // Rebuild the processed HTML when the font changes so the matching {{{CUSTOM_FONT}}} rules are injected
  private OnFontChange(){
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Function handling action buttons change between link or button
  private ChangeRadioType(isLink: boolean, buttonType: number) {
    const editableTemplateData = this.editTemplateData.TemplateData;
    const originalTemplateData = this.templatePreviewData.TemplateData;

    switch (buttonType) {
    case InviteCTATypeEnum.Register:
      editableTemplateData.HasRegistrationLink = isLink;

      if (!isLink) {
        // BUTTON mode
        const shouldUseDefaults = originalTemplateData.HasRegistrationLink;
        this.registerButtonBackgroundColor.hex = shouldUseDefaults ? this.defaultBackgroundColor : originalTemplateData.BackgroundColor;
        this.registerButtonFontColor.hex = shouldUseDefaults ? this.defaultForegroundColor : originalTemplateData.LabelColor;
        editableTemplateData.LabelColor = shouldUseDefaults ? this.defaultForegroundColor : originalTemplateData.LabelColor;
        editableTemplateData.BackgroundColor = shouldUseDefaults ? this.defaultBackgroundColor : originalTemplateData.BackgroundColor;
      } else {
        // LINK mode
        const labelColor = originalTemplateData.HasRegistrationLink ? originalTemplateData.LabelColor : ConfigureEmailsHelper.CTALinkColor;
        const backgroundColor = originalTemplateData.HasRegistrationLink ? originalTemplateData.BackgroundColor : this.defaultBackgroundColor;
        this.registerButtonFontColor.hex = labelColor;
        this.registerButtonBackgroundColor.hex = backgroundColor;
        editableTemplateData.LabelColor = labelColor;
        editableTemplateData.BackgroundColor = backgroundColor;
      }
      break;

    case InviteCTATypeEnum.EditResponse:
      editableTemplateData.HasEditResponsesRegistrationLink = isLink;
      const editLabel = originalTemplateData.EditResponsesLabelColor || this.defaultForegroundColor;
      const editBg = originalTemplateData.EditResponsesBackgroundColor || this.defaultBackgroundColor;

      if (!isLink) {
        // BUTTON mode
        const labelColor = originalTemplateData.HasEditResponsesRegistrationLink ? this.defaultForegroundColor : editLabel;
        const backgroundColor = originalTemplateData.HasEditResponsesRegistrationLink ? this.defaultBackgroundColor : editBg;
        this.editButtonBackgroundColor.hex = backgroundColor;
        this.editButtonFontColor.hex = labelColor;
        editableTemplateData.EditResponsesLabelColor = labelColor;
        editableTemplateData.EditResponsesBackgroundColor = backgroundColor;
      } else {
        // LINK mode
        const labelColor = originalTemplateData.HasEditResponsesRegistrationLink ? editLabel : ConfigureEmailsHelper.CTALinkColor;
        const backgroundColor = originalTemplateData.HasEditResponsesRegistrationLink ? editBg : this.defaultBackgroundColor;
        this.editButtonFontColor.hex = labelColor;
        this.editButtonBackgroundColor.hex = backgroundColor;
        editableTemplateData.EditResponsesLabelColor = labelColor;
        editableTemplateData.EditResponsesBackgroundColor = backgroundColor;
      }
      break;

    case InviteCTATypeEnum.EventAccess:
      editableTemplateData.HasEventAccessLink = isLink;
      const eventLabel = originalTemplateData.EventAccessLabelColor || this.defaultForegroundColor;
      const eventBg = originalTemplateData.EventAccessBackgroundColor || this.defaultBackgroundColor;

      if (!isLink) {
        // BUTTON mode
        const labelColor = originalTemplateData.HasEventAccessLink ? this.defaultForegroundColor : eventLabel;
        const backgroundColor = originalTemplateData.HasEventAccessLink ? this.defaultBackgroundColor : eventBg;
        this.eventAccessButtonBackgroundColor.hex = backgroundColor;
        this.eventAccessButtonFontColor.hex = labelColor;
        editableTemplateData.EventAccessLabelColor = labelColor;
        editableTemplateData.EventAccessBackgroundColor = backgroundColor;
      } else {
        // LINK mode
        const labelColor = originalTemplateData.HasEventAccessLink ? eventLabel : ConfigureEmailsHelper.CTALinkColor;
        const backgroundColor = originalTemplateData.HasEventAccessLink ? eventBg : this.defaultBackgroundColor;
        this.eventAccessButtonFontColor.hex = labelColor;
        this.eventAccessButtonBackgroundColor.hex = backgroundColor;
        editableTemplateData.EventAccessLabelColor = labelColor;
        editableTemplateData.EventAccessBackgroundColor = backgroundColor;
      }
      break;

    case InviteCTATypeEnum.EventWebPage:
      editableTemplateData.HasEventWebPageAccessLink = isLink;
      const ewpLabel = originalTemplateData.EventWebPageAccessLabelColor || this.defaultForegroundColor;
      const ewpBg = originalTemplateData.EventWebPageAccessBackgroundColor || this.defaultBackgroundColor;

      if (!isLink) {
        // BUTTON mode
        const labelColor = originalTemplateData.HasEventWebPageAccessLink ? this.defaultForegroundColor : ewpLabel;
        const backgroundColor = originalTemplateData.HasEventWebPageAccessLink ? this.defaultBackgroundColor : ewpBg;
        this.eventWebPageButtonBackgroundColor.hex = backgroundColor;
        this.eventWebPageButtonFontColor.hex = labelColor;
        editableTemplateData.EventWebPageAccessLabelColor = labelColor;
        editableTemplateData.EventWebPageAccessBackgroundColor = backgroundColor;
      } else {
        // LINK mode
        const labelColor = originalTemplateData.HasEventWebPageAccessLink ? ewpLabel : ConfigureEmailsHelper.CTALinkColor;
        const backgroundColor = originalTemplateData.HasEventWebPageAccessLink ? ewpBg : this.defaultBackgroundColor;
        this.eventWebPageButtonFontColor.hex = labelColor;
        this.eventWebPageButtonBackgroundColor.hex = backgroundColor;
        editableTemplateData.EventWebPageAccessLabelColor = labelColor;
        editableTemplateData.EventWebPageAccessBackgroundColor = backgroundColor;
      }
      break;
    }
    this.GenerateBodyHTML();
  }

  private OnButtonTextChange(){
    this.GenerateBodyHTML();
  }

  // Function for opening Merge tags modal
  private OpenMergeTagsModal(){
    const selectedTemplateType = this.editTemplateData.TemplateData.TemplateType.toLowerCase();
    const tags = this.mergeTags.mergeTagsData.find((item) => item.TemplateType.toLowerCase() === selectedTemplateType)?.TagName || [];
    const personalisedEventAccessLinkTags = ['{{PersonalEventAccessLink}}', '{{PersonalEventAccessLinkQR}}'];

    if(this.reqInfo.EnablePersonalisedEventAccessLink && this.HasConfirmationTemplate() && !personalisedEventAccessLinkTags.every((tag) => tags.includes(tag))){
      tags.unshift(...personalisedEventAccessLinkTags);
    }
    const newTags = [  '{{PersonalEventAccessLink}}',  '{{PersonalEventAccessLinkQR}}' , '{{EventAccessLinkQR}}', '{{EventWebPageLink}}'];
    const listItems = tags
      .map((tag: string) => {
        const isNewTag = newTags.includes(tag);
        return `
      <li class="padding-top-10 padding-bottom-10">${tag}<img class="margin-left-10 cursor-pointer copy-icon margin-right-15 " src="${this.copyIcon}"/>
        ${isNewTag ? `<span class="highlight-badge">${this.$t('New').toString()}</span>` : ''}
      </li>
    `;
      })
      .join('');

    // Full HTML structure
    const html = `<p class="font-weight-600">${this.$t('Invite.ConfigureEmails.MergeTagsModalDescription').toString()}</p>
          <ul class="padding-left-25"> ${listItems} </ul>`;

    this.showConfigureEmailEditPaneModal = true;
    this.customEmailModalPopUp.Heading = this.$t('Invite.ConfigureEmails.MergeTagsHeading').toString();
    this.customEmailModalPopUp.ModelDescription = html;
    this.customEmailModalPopUp.IsMergeTagsOpen = true;
    this.customEmailModalPopUp.ShowButton1 = false;
    this.customEmailModalPopUp.Button2Text = this.$t('Button.Close').toString();
  }

  // Hero Image process handler
  private ShowImageProcessSection(): boolean {
    return this.showImageProcess;
  }

  // Function for closing input modal
  private HandleCloseModal(){
    this.showConfigureEmailEditPaneModal = false;
    this.customEmailModalPopUp.ModelDescription = '';
    this.customEmailModalPopUp.ShowButton1 = true;
    this.customEmailModalPopUp.IsMergeTagsOpen = false;
  }

  // Function for closing Vue Modal
  private CloseModelPopup(){
    this.showVueModalPopUp = false;
    this.shouldSwitchToHomeScreen = false;
    this.shouldSwitchToTemplatesScreen = false;
  }

  // Function calling eith Save Template or SendPreviewMail based on Mode
  private HandleRecievedData(templateData: EmailTemplatesTableModel, templateName: string){
    this.SaveTemplate(templateData, templateName);
  }

  // Parent controls child
  private OpenUnsavedChangesinEditPane(){
    this.shouldSwitchToHomeScreen = true;
    this.showVueModalPopUp = true;
    this.unsavedModalPopUp = new VueModalPopUpViewModel(
      this.$t('UnsavedChanges').toString(),
      this.$t('EventSetting.UnsavedItems').toString(),
      true,
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      require('@/assets/Images/Icon-warning.svg'),
      this.$t('CancelButton').toString(),
      this.$t('SaveAndSwitch').toString(),
    );
  }

  // Function to be articulated
  private  SaveModelPopUp(){
    this.showVueModalPopUp = false;
    this.SaveEmailConfigurations(this.v$);
  }

  // Function recieving emit from email modal
  private ConfirmEmailPopupClick(val: any) {
    this.SendPreviewMail(val);
    this.showEmailModalPopUp = false;
  }

  // Function for closing the input modal
  private CloseInputModelPopup(){
    this.showEmailModalPopUp = false;
  }

  // Used for checking whether page contains unsaved data
  private IsPageDirty() {
    if(this.showEventPageNotPublishInformation && this.HasEventWebPageAccessTemplate()){
      this.isPageDirty = false;
      this.$emit('page-is-dirty', this.isPageDirty);
      return;
    }
    if(this.editTemplateData.TemplateData.IsSelected === false){
      this.isPageDirty = true;
    }else{
      const objectState = (JSON.stringify(this.templatePreviewData.TemplateData) === JSON.stringify(this.editTemplateData.TemplateData));
      if (!objectState ) {
        this.isPageDirty = true;
      } else {
        this.isPageDirty = false;
      }
    }
    this.$emit('page-is-dirty', this.isPageDirty);
  }

  // Common function for showing and hiding toaster message and loader
  private ShowToasterAndLoader(toasterMessage: string) {
    this.toasterMessage = toasterMessage;
    this.showToaster = true;
    setTimeout(() => {
      this.showLoading = false;
      setTimeout(() => {
        this.showToaster = false;
      }, this.toasterDefaultTimeout);
    }, this.loaderDefaultTimeout);
  }


  // function for changing body content
  private ChangeBodyDescription(description: string){
    if(description !== null  && description !== undefined){
      this.editTemplateData.TemplateData.EmailBody = description;
      this.GenerateBodyHTML();
    }
  }

  // Handler for closing modal pop up of save
  private CloseSaveTemplateModal() {
    this.showConfigureEmailEditPaneModal = false;
  }

  // Function checking f required fields are filled or not
  private IsMandatoryFieldsFilled(){
    this.validationErrorFields = [];
    if(this.editTemplateData.TemplateData.EmailSubject === ''){
      this.validationErrorFields.push(
        this.$t('Invite.ConfigureEmails.EditEmail.Subject').toString(),
      );
    }
    if(((this.HasConfirmationTemplate()) && (this.editTemplateData.TemplateData.EditResponsesLabelText === '' || this.editTemplateData.TemplateData.EventAccessLabelText === '')) || this.editTemplateData.TemplateData.LabelText === ''){
      this.validationErrorFields.push(
        this.$t('ButtonTitle').toString(),
      );
    }
    if(this.validationErrorFields.length > 0){
      this.isValidationSummaryVisible = true;
      this.ScrollContainerToTop('dvEmailContainer');
      this.showConfigureEmailEditPaneModal = false;
      return false;
    }
    return true;
  }

  // Function for saving as a new template or overwriting existing template inside DB
  private SaveTemplate(templateData: EmailTemplatesTableModel, inputText: string){
    if(!this.IsMandatoryFieldsFilled()){
      return;
    }
    this.showLoading = true;
    let toasterMessage = '';
    if((templateData !== null && templateData !== undefined) && inputText === ''){
      this.editTemplateData.TemplateData.Id = templateData.Id;
      this.editTemplateData.TemplateData.TemplateName = templateData.TemplateName;
      toasterMessage = this.$t('Invite.ConfigureEmails.SavedEmailSettings').toString();
    } else{
      this.editTemplateData.TemplateData.Id = 0;
      this.editTemplateData.TemplateData.TemplateName = inputText;
      toasterMessage = this.$t('Invite.ConfigureEmails.TemplateSavedSuccessfully').toString();
    }

    this.editTemplateData.TemplateData.EmailBody = this.editTemplateData.TemplateData.EmailBody.replace(  /\{\{AddToCalendarIMG\}\}/gi,
      '<img src=\'{{AddToCalendarIMG}}\'/>');
    const formData = new FormData();
    const json = JSON.stringify(this.editTemplateData.TemplateData);
    // Encode json string to base64 using Buffer:
    const b64 = Buffer.from(json, 'utf-8').toString('base64');
    formData.append('emailTemplateData',b64);
    if(!!this.imagesToBeUploaded && this.imagesToBeUploaded.length > 0) {
      this.imagesToBeUploaded.forEach((imageUpload, index) => {
        // Append metadata as JSON or individual fields
        formData.append(`telerikImagesUploads[${index}].Id`, imageUpload.Id);
        formData.append(`telerikImagesUploads[${index}].ImageWidth`, imageUpload.ImageWidth.toString());
        formData.append(`telerikImagesUploads[${index}].ImageHeight`, imageUpload.ImageHeight.toString());
        formData.append(`telerikImagesUploads[${index}].File`, imageUpload.File!);
      });
    }
    FetchData('/Registration/SaveEmailTemplate', formData, ApiContentType.FormData).then(() => {
      this.ShowToasterAndLoader(toasterMessage);
      this.$emit('reload-template-data');
    }).catch(()=>{
      this.showLoading = false;
    });
    this.CloseSaveTemplateModal();
  }

  // Function for Footer content change
  private ChangeFooterDescription(description: string){
    if(description !== null && description !== undefined){
      this.editTemplateData.TemplateData.FooterContent = description;
      this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
    }
  }

  // Get Default colors for the emails
  private SetDefaultColors(){
    this.headerBackgroundColor.hex = this.editTemplateData.TemplateData.HeaderAccentColor || this.defaultBackgroundColor;
    this.bodyBackgroundColor.hex = this.editTemplateData.TemplateData.EmailAccentColor || ConfigureEmailsHelper.EmailAccentColor;
    this.bodyFontColor.hex = this.editTemplateData.TemplateData.EmailTextColor || ConfigureEmailsHelper.EmailTextColor;
    this.footerBackgroundColor.hex = this.editTemplateData.TemplateData.FooterAccentColor || this.defaultBackgroundColor;
    this.footerFontColor.hex = this.editTemplateData.TemplateData.FooterTextColor || this.defaultForegroundColor;
    this.registerButtonBackgroundColor.hex = this.editTemplateData.TemplateData.BackgroundColor;
    this.registerButtonFontColor.hex = this.editTemplateData.TemplateData.LabelColor;
    if(this.editTemplateData.TemplateData.TemplateType === InviteConfirmationEmailEnum.Confirmation  || this.editTemplateData.TemplateData.TemplateType === InviteConfirmationEmailEnum.ConfirmationTickets){
      this.editButtonBackgroundColor.hex = this.editTemplateData.TemplateData.EditResponsesBackgroundColor || this.defaultBackgroundColor;
      this.editButtonFontColor.hex = this.editTemplateData.TemplateData.EditResponsesLabelColor || this.defaultForegroundColor;
      this.eventAccessButtonBackgroundColor.hex = this.editTemplateData.TemplateData.EventAccessBackgroundColor || this.defaultBackgroundColor;
      this.eventAccessButtonFontColor.hex = this.editTemplateData.TemplateData.EventAccessLabelColor || this.defaultForegroundColor;
    }
    if(this.editTemplateData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.Invitation || this.editTemplateData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.InvitationReminder || this.editTemplateData.TemplateData.TemplateType === InviteEventWebPageEmailTypeEnum.Custom){
      this.editTemplateData.TemplateData.EventWebPageAccessBackgroundColor = this.editTemplateData.TemplateData.EventWebPageAccessBackgroundColor || this.defaultBackgroundColor;
      this.editTemplateData.TemplateData.EventWebPageAccessLabelColor = this.editTemplateData.TemplateData.EventWebPageAccessLabelColor || this.defaultForegroundColor;
      this.eventWebPageButtonBackgroundColor.hex = this.editTemplateData.TemplateData.EventWebPageAccessBackgroundColor;
      this.eventWebPageButtonFontColor.hex = this.editTemplateData.TemplateData.EventWebPageAccessLabelColor;
    }
  }

  // Set Default Hero Image settings
  private GetHeroImageUrl(){
    return !!this.editTemplateData.TemplateData.HeroImageUrl && this.editTemplateData.TemplateData.HeroImageUrl !== '' ? this.editTemplateData.TemplateData.HeroImageUrl : this.missingFeatureImage;
  }

  // Set Default Logo settings
  private GetLogoImageUrl(){
    return !!this.editTemplateData.TemplateData.LogoUrl && this.editTemplateData.TemplateData.LogoUrl !== '' ? this.editTemplateData.TemplateData.LogoUrl : this.missingImage;
  }

  // Send preview Pop up modal
  private OpenSendPreviewPopUp(){
    this.showEmailModalPopUp = true;
    this.emailModalPopUp.ValidationErrors = [];
    {
      const validationErrors =  ModalInputPopUpValidationsModel.createEmpty();
      validationErrors.Regex = '';
      validationErrors.ValidationMessage = this.$t('Email').toString();
      this.emailModalPopUp.ValidationErrors.push(validationErrors);
    }
    {
      const validationErrors =  ModalInputPopUpValidationsModel.createEmpty();
      validationErrors.Regex = '^([A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,})(\\s*,\\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,})*$';
      validationErrors.ValidationMessage = this.$t('Invite.ConfigureEmails.EmailFormatWarning').toString();
      this.emailModalPopUp.ValidationErrors.push(validationErrors);
    }
    this.emailModalPopUp.Heading = this.$t('Invite.ConfigureEmails.SendPreviewMail').toString();
    this.emailModalPopUp.InputType = ModalInputType.Email;
    this.emailModalPopUp.SecondaryButtonText = this.$t('Button.Cancel');
    this.emailModalPopUp.PrimaryButtonText = this.$t('Button.Send');
    this.emailModalPopUp.Placeholder = this.$t('Invite.ConfigureEmails.SendPreviewModalPlaceholder').toString();
  }

  // Function for managing Save as template modal pop up
  private OpenSaveAsTemplatePopUp(){
    this.showConfigureEmailEditPaneModal = true;
    if(this.editTemplateData.AvailableTemplates.length > 0){
      this.customEmailModalPopUp.Heading = this.$t('Invite.ConfigureEmails.ModalHeading.SelectOrOverwriteTemplate').toString();
    } else{
      this.customEmailModalPopUp.Heading = this.$t('Invite.ConfigureEmails.ModalHeading.EnterTemplateName').toString();
    }
    this.customEmailModalPopUp.Placeholder = this.$t('Invite.ConfigureEmails.InputModalPlaceholder').toString();
    this.customEmailModalPopUp.Button1Text = this.$t('Button.Cancel');
    this.customEmailModalPopUp.Button2Text = this.$t('Button.Save');
  }

  private ClickOnImage(val: boolean){
    this.showImageProcess = val;
    this.showHeroImage = false;
    this.subModuleName = SubModulePrefix.IconImage;
    this.$emit('hide-back-navigation-button', val);
  }

  // Function managing hero image & logo image rendering
  private ClickOnBackgroundImage(imageType: number) {
    if(imageType === InviteImageTypeEnum.HeroImage){
      this.showHeroImage = true;
      this.subModuleName = SubModulePrefix.BackgroundImage;
    }else{
      this.subModuleName = SubModulePrefix.IconImage;
    }
    this.showImageProcess = true;
    this.$emit('hide-back-navigation-button', true);
  }

  // Warning message for logo image
  private GetLogoWarning(){
    return this.$t('Invite.ConfigureEmails.LogoWarning', {size: ConfigureEmailsHelper.LogoMaxSize,height: ConfigureEmailsHelper.LogoMinHeight});
  }

  // Warning message for Hero image
  private GetHeroImageWarning(){
    return this.$t('ImageProcess.BackgroundImageMessageForRatio16:9', {backgroundImageWidthRatio: ConfigureEmailsHelper.HeroImageWidthRatio, backgroundImageHeightRatio: ConfigureEmailsHelper.HeroImageHeightRatio, maxBackgroundImageSize: ConfigureEmailsHelper.HeroImageMaxSize, backgroundImageWidth: ConfigureEmailsHelper.HeroImageMaxWidth, backgroundImageHeight: ConfigureEmailsHelper.HeroImageMaxHeight });
  }

  // Function for reverting back to old Logo settings
  private SetLogoOldUrl(){
    const previousLogo = this.templatePreviewData.TemplateData.LogoUrl;
    this.editTemplateData.TemplateData.LogoUrl = previousLogo;
    this.customEmailLogoData.ImageUrl = this.templatePreviewData.TemplateData.LogoUrl || (!!this.editTemplateData.TemplateData.HeaderAccentColor ? '' : this.defaultLogo);
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Function for reverting back to old Hero Image settings
  private SetHeroImgOldUrl(){
    this.editTemplateData.TemplateData.HeroImageUrl = this.templatePreviewData.TemplateData.HeroImageUrl;
    this.customEmailHeroImageData.ImageUrl = this.templatePreviewData.TemplateData.HeroImageUrl;
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Setting new Logo
  private SetLogoUrl(imgurl: string, _mainMediaFullUrl: string, IsLogoUrl: boolean) {
    if(IsLogoUrl === undefined || IsLogoUrl === false) {
      this.editTemplateData.TemplateData.LogoUrl = imgurl.includes('data:image/png') ? '' : imgurl;
      this.customEmailLogoData.ImageUrl = this.editTemplateData.TemplateData.LogoUrl;
      this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
    }
  }

  // Setting new Hero Image
  private SetHerologoUrl(imgurl: string) {
    if(imgurl !== null || imgurl !== undefined){
      this.editTemplateData.TemplateData.HeroImageUrl = imgurl === undefined ? '' : imgurl;
      this.customEmailHeroImageData.ImageUrl = this.editTemplateData.TemplateData.HeroImageUrl;
      this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
    }
  }

  // Set new Logo for the Email Template
  private SetLogoData(){
    this.customEmailLogoData.ImageDescription = this.GetLogoWarning();
    this.customEmailLogoData.ImageUrl = this.editTemplateData.TemplateData.LogoUrl || (!!this.editTemplateData.TemplateData.HeaderAccentColor ? '' : this.defaultLogo);
    this.customEmailLogoData.ImageBackground = this.editTemplateData.TemplateData.HeaderAccentColor || this.defaultBackgroundColor;
    this.customEmailLogoData.ImageHeading = this.$t('Logo').toString();
    this.customEmailLogoData.DescriptionMargin = '25px 0px 0px';
    this.editTemplateData.TemplateData.LogoPosition = this.editTemplateData.TemplateData.LogoPosition || ConfigureEmailsHelper.LogoPosition;
  }

  // Set new Banner image for the email template
  private SetHeroImageData() {
    this.customEmailHeroImageData.ImageDescription = this.GetHeroImageWarning();
    this.customEmailHeroImageData.ShowImageDescription = true;
    this.customEmailHeroImageData.ImageUrl = this.editTemplateData.TemplateData.HeroImageUrl;
    this.customEmailHeroImageData.IsLogoMandatory = false;
    this.customEmailHeroImageData.ImageHeading = this.$t('Invite.ConfigureEmails.HeroImage').toString();
    this.customEmailHeroImageData.ShowImageHeading = true;
    this.customEmailHeroImageData.DescriptionMargin = '25px 0px 0px';
  }

  // Colors pallete toggler
  private TogglePalette(index: number) {
    this.HideAllPalattes();
    this.isPaletteSelected[index] = !this.isPaletteSelected[index];
  }
  private HideAllPalattes() {
    this.isPaletteSelected.forEach((element, index) => {
      this.isPaletteSelected[index] = false;
    });
  }
  private SetImagesToBeUploadedData(val: TelerikImageUploadViewModel[]) {
    this.imagesToBeUploaded = val.reduce(
      (acc, item2) => {
        if (!acc.some((item1) => item1.Id === item2.Id)) {
          acc.push(item2);
        }
        return acc;
      },
      [...this.imagesToBeUploaded],
    );
  }
  // Emit event to change template
  private EmitChangeTemplate(){
    if(this.isPageDirty){
      this.shouldSwitchToTemplatesScreen = true;
      this.showVueModalPopUp = true;
      this.unsavedModalPopUp = new VueModalPopUpViewModel(
        this.$t('UnsavedChanges').toString(),
        this.$t('EventSetting.UnsavedItems').toString(),
        true,
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        require('@/assets/Images/Icon-warning.svg'),
        this.$t('CancelButton').toString(),
        this.$t('SaveAndSwitch').toString(),
      );
    }else{
      this.$emit('change-template-screen');
    }
  }

  // Emit event to hide edit screen
  private DiscardChanges(){
    if(this.editTemplateData.TemplateData.IsSelected === false){
      this.$emit('discard-template');
    }else{
      this.editTemplateData = JSON.parse(JSON.stringify(this.templatePreviewData));
    }
    this.editTemplateData.TemplateData.FontFamily = this.editTemplateData.TemplateData.FontFamily || InviteEmailFontsEnum.Verdana;
    this.SetDefaultColors();
    this.SetLogoOldUrl();
    this.SetHeroImgOldUrl();
    this.GenerateBodyHTML();
    this.customEmailLogoData.ImageBackground = this.editTemplateData.TemplateData.HeaderAccentColor;
    this.state.editTemplateData = this.editTemplateData;
    this.validationErrorFields = [];
    this.isValidationSummaryVisible = false;
    this.imagesToBeUploaded = [];
  }

  // Check for required fields validation
  private CheckRequiredFields(val: any){
    val.$touch();
    this.validationErrorFields = [];
    if(val.editTemplateData.TemplateData.EmailSubject!.$error === true){
      this.validationErrorFields.push(
        this.$t('Invite.ConfigureEmails.EditEmail.Subject').toString(),
      );
    }
    if( ((this.HasConfirmationTemplate()) && (val.editTemplateData.TemplateData.EditResponsesLabelText!.$error === true || val.editTemplateData.TemplateData.EventAccessLabelText!.$error === true)) || val.editTemplateData.TemplateData.LabelText!.$error === true){
      this.validationErrorFields.push(
        this.$t('ButtonTitle').toString(),
      );
    }
    if(this.HasEventWebPageAccessTemplate() && val.editTemplateData.TemplateData.EventWebPageAccessLabelText!.$error === true){
      this.validationErrorFields.push(
        this.$t('ButtonTitle').toString(),
      );
    }
    if(this.validationErrorFields.length > 0){
      return true;
    } else{
      return false;
    }
  }

  // Scroll to the top of the page for showing validation summary
  private ScrollContainerToTop(containerId: string) {
    if (typeof document === 'undefined') {
      return;
    }
    const element = document.getElementById(containerId);
    if (!element) {
      return;
    }
    // Smooth scroll inside the container
    element.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  // Function to be called for saving email configurations
  private  SaveEmailConfigurations(val: any){
    if(this.CheckRequiredFields(val)){
      this.isValidationSummaryVisible = true;
      this.ScrollContainerToTop('dvEmailContainer');
      return;
    } else{
      this.editTemplateData.TemplateData.Id = this.editTemplateData.SelectedTemplate.Id;
      this.editTemplateData.TemplateData.EventPageId = this.editTemplateData.SelectedTemplate.EventPageId;
      this.editTemplateData.TemplateData.EmailBody = this.editTemplateData.TemplateData.EmailBody.replace(  /\{\{AddToCalendarIMG\}\}/gi,
        '<img src=\'{{AddToCalendarIMG}}\'/>');
      const formData = new FormData();
      const json = JSON.stringify(this.editTemplateData.TemplateData);
      // Encode json string to base64 using Buffer:
      const b64 = Buffer.from(json, 'utf-8').toString('base64');
      formData.append('emailConfirgurationData',b64);
      if(!!this.imagesToBeUploaded && this.imagesToBeUploaded.length > 0) {
        this.imagesToBeUploaded.forEach((imageUpload, index) => {
        // Append metadata as JSON or individual fields
          formData.append(`telerikImagesUploads[${index}].Id`, imageUpload.Id);
          formData.append(`telerikImagesUploads[${index}].ImageWidth`, imageUpload.ImageWidth.toString());
          formData.append(`telerikImagesUploads[${index}].ImageHeight`, imageUpload.ImageHeight.toString());
          formData.append(`telerikImagesUploads[${index}].File`, imageUpload.File!);
        });
      }

      this.$emit('save-email-configurations', formData , this.shouldSwitchToHomeScreen, this.shouldSwitchToTemplatesScreen);
      if(this.editTemplateData.TemplateData.IsSelected === false){
        this.ShowToasterAndLoader(this.$t('Invite.ConfigureEmails.SavedEmailSettings').toString());
      }
      this.validationErrorFields = [];
      this.showLoading = false;
      this.isValidationSummaryVisible = false;
    }
  }
  // Used to show hide tooltip on mouse hover over info icon
  private ShowHideFontFamilyInformationString(val: boolean) {
    this.showFontFamilyInformation = val;
  }
  // Watch for managaing changes in the colors palettes for Header Background color
  @Watch('headerBackgroundColor')
  private CheckChangeInHeaderBackgroundColor(newColor: {hex: ''}){
    this.headerBackgroundColor = newColor;
    this.editTemplateData.TemplateData.HeaderAccentColor = newColor.hex;
    this.customEmailLogoData.ImageBackground = newColor.hex;
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Watch for managaing changes in the colors palettes for bodyBackgroundColor color
  @Watch('bodyBackgroundColor')
  private CheckChangeInBodyBackgroundcolor(newColor: {hex: ''}){
    this.bodyBackgroundColor = newColor;
    this.editTemplateData.TemplateData.EmailAccentColor = newColor.hex;
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Watch for managaing changes in the colors palettes for footerBackgroundColor color
  @Watch('footerBackgroundColor')
  private CheckChangeInFooterBackgroundColor(newColor: {hex: ''}){
    this.footerBackgroundColor = newColor;
    this.editTemplateData.TemplateData.FooterAccentColor = newColor.hex;
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Watch for managaing changes in the colors palettes for footerFontColor color
  @Watch('footerFontColor')
  private CheckChangeInFooterFontColor(newColor: {hex: ''}){
    this.footerFontColor = newColor;
    this.editTemplateData.TemplateData.FooterTextColor = newColor.hex;
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Watch for managaing changes in the colors palettes for registerButtonBackgroundColor color
  @Watch('registerButtonBackgroundColor')
  private CheckChangeInButtonAccentBgColor(newColor: {hex: ''}){
    this.registerButtonBackgroundColor = newColor;
    this.editTemplateData.TemplateData.BackgroundColor = newColor.hex;
    this.GenerateBodyHTML();
  }

  // Watch for managaing changes in the colors palettes for registerButtonFontColor color
  @Watch('registerButtonFontColor')
  private CheckChangeInButtonAccentFontColor(newColor: {hex: ''}){
    this.registerButtonFontColor = newColor;
    this.editTemplateData.TemplateData.LabelColor = newColor.hex;
    this.GenerateBodyHTML();
  }

  // Watch for managaing changes in the colors palettes for bodyFontColor color
  @Watch('bodyFontColor')
  private CheckChangeInBodyFontColor(newColor: {hex: ''}){
    this.bodyFontColor = newColor;
    this.editTemplateData.TemplateData.EmailTextColor = newColor.hex;
    this.editTemplateData.ProcessedHtml = this.BuildProcessedHtml();
  }

  // Watch for managaing changes in the colors palettes for editButtonBackgroundColor color
  @Watch('editButtonBackgroundColor')
  private CheckChangeInEditButtonAccentColor(newColor: {hex: ''}){
    this.editButtonBackgroundColor = newColor;
    this.editTemplateData.TemplateData.EditResponsesBackgroundColor = newColor.hex;
    this.GenerateBodyHTML();
  }

  // Watch for managaing changes in the colors palettes for editButtonFontColor color
  @Watch('editButtonFontColor')
  private CheckChangeInEditButtonFontColor(newColor: {hex: ''}){
    this.editButtonFontColor = newColor;
    this.editTemplateData.TemplateData.EditResponsesLabelColor = newColor.hex;
    this.GenerateBodyHTML();
  }

  // Watch for managaing changes in the colors palettes for eventAccessButtonBackgroundColor color
  @Watch('eventAccessButtonBackgroundColor')
  private CheckChangeInEventAccessButtonBackgroundColor(newColor: {hex: ''}){
    this.eventAccessButtonBackgroundColor = newColor;
    this.editTemplateData.TemplateData.EventAccessBackgroundColor = newColor.hex;
    this.GenerateBodyHTML();
  }
  // Watch for managaing changes in the colors palettes for eventAccessButtonFontColor color
  @Watch('eventAccessButtonFontColor')
  private CheckChangeInEventAccessButtonFontColor(newColor: {hex: ''}){
    this.eventAccessButtonFontColor = newColor;
    this.editTemplateData.TemplateData.EventAccessLabelColor = newColor.hex;
    this.GenerateBodyHTML();
  }

  // Watch for managing changes in the colors palettes for eventWebPageBackgroundColor color
  @Watch('eventWebPageButtonBackgroundColor')
  private CheckChangeInEventWebPageBackgroundColor(newColor: {hex: ''}){
    this.eventWebPageButtonBackgroundColor = newColor;
    this.editTemplateData.TemplateData.EventWebPageAccessBackgroundColor = newColor.hex;
    this.GenerateBodyHTML();
  }

  // Watch for managaing changes in the colors palettes for eventWebPageFontColor color
  @Watch('eventWebPageButtonFontColor')
  private CheckChangeInEventWebPageFontColor(newColor: {hex: ''}){
    this.eventWebPageButtonFontColor = newColor;
    this.editTemplateData.TemplateData.EventWebPageAccessLabelColor = newColor.hex;
    this.GenerateBodyHTML();
  }

  // Watch for updating my local variable with new Prop changes
  @Watch('templatePreviewData')
  private CheckPropChanges(){
    this.SetDefaultEmailSettings();
    this.editTemplateData = JSON.parse(JSON.stringify(this.templatePreviewData));
    this.state.editTemplateData = this.editTemplateData;
    this.IsPageDirty();
    this.SetLogoData();
    this.SetHeroImageData();
    this.SetDefaultColors();
  }
}
export default toNative(ConfigureEmailEditPane);
